import { ObjectSchema } from "@hapi/joi";

import Joi, { getNumericErrors } from "fe-shared/src/helpers/validation";
import { ErrorMessages } from "fe-shared/src/types/common";
import { COMMENT_LENGTH_LIMIT } from "../../../consts";
import { CreateReceiptFormValues } from "../../../types";

export const MAX_TOTAL_WEIGHT = 99999999999999;

export const errorMessages: ErrorMessages = {
  scaleTicketNumber: {
    "string.empty": "validation.ticketNumberRequired",
    "string.max": "validation.ticketNumberRequired",
  },
  targetWarehouseId: {
    "number.base": "validation.targetWarehouseRequired",
    "any.required": "validation.targetWarehouseRequired",
  },
  grossWeight: {
    ...getNumericErrors("validation.grossRequired", "validation.grossInvalid"),
    "any.required": "validation.grossRequired",
  },
  tareWeight: {
    ...getNumericErrors("validation.tareRequired", "validation.tareInvalid"),
    "any.required": "validation.tareRequired",
  },
  actualTransactionDate: {
    "any.required": "validation.transactionDateRequired",
    "date.base": "validation.transactionDateRequired",
    "date.max": "validation.transactionDateFuture",
  },
};

export const getValidationConfig = (): ObjectSchema<CreateReceiptFormValues> =>
  Joi.object({
    scaleTicketNumber: Joi.string().max(256).required(),
    grossWeight: Joi.when("tareWeight", {
      is: Joi.number().integer().min(1).required(),
      then: Joi.number()
        .integer()
        .min(Joi.ref("tareWeight"))
        .max(MAX_TOTAL_WEIGHT)
        .required(),
      otherwise: Joi.number()
        .integer()
        .min(0)
        .max(MAX_TOTAL_WEIGHT)
        .required(),
    }),
    tareWeight: Joi.number()
      .integer()
      .min(1)
      .max(MAX_TOTAL_WEIGHT)
      .required(),
    comment: Joi.string().max(COMMENT_LENGTH_LIMIT).allow("", null),
    scaleTicketFiles: Joi.array(),
    tirePhotoFiles: Joi.array(),
    attachments: Joi.array(),
    targetWarehouseId: Joi.number().integer().required(),
    trailerNumber: Joi.string().allow("", null),
    actualTransactionDate: Joi.when(
      "useActualTransactionDateAsScaleTicketDate",
      {
        is: true,
        then: Joi.date().max("now").required(),
        otherwise: Joi.date().max("now").allow("", null),
      }
    ),
    useActualTransactionDateAsScaleTicketDate: Joi.boolean().required(),
  });
